import { formatNumber } from 'util/formatNumber';
import { pxToEm } from 'util/pxToEm';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

export interface StatDisplayProps {
  icon: ReactElement;
  label: string;
  value: number | undefined;
}

export const StatDisplay = ({
  icon,
  label,
  value,
}: StatDisplayProps): ReactElement => {
  return (
    <Box display="flex" alignItems="center">
      <Box mr={10}>
        <Typography
          color="primary"
          style={{
            fontSize: pxToEm(20),
            color: '#383838',
            lineHeight: 0,
          }}
        >
          {icon}
        </Typography>
      </Box>
      <Typography
        style={{
          fontWeight: 500,
          fontSize: pxToEm(14),
          color: '#383838',
          whiteSpace: 'nowrap',
          paddingRight: 16,
        }}
      >
        {label}
      </Typography>
      <Box
        marginLeft={{ xs: 'auto', md: 'unset' }}
        sx={{
          padding: 10,
          borderRadius: 10,
          backgroundColor: '#F7F7F7',
          border: '1px solid #EFEFEF',
          minWidth: 55,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Typography
          style={{
            fontSize: pxToEm(14),
            color: '#383838',
          }}
        >
          {formatNumber(value)}
        </Typography>
      </Box>
    </Box>
  );
};
